export async function copyTextToClipboard(text: string) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.left = "0";
  textArea.style.top = "0";
  textArea.style.width = "1px";
  textArea.style.height = "1px";
  textArea.style.border = "0";
  textArea.style.opacity = "0";
  textArea.style.padding = "0";
  textArea.style.pointerEvents = "none";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, text.length);

  const copied = document.execCommand("copy");
  document.body.removeChild(textArea);

  if (copied) {
    return;
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    throw new Error("Copy command failed", { cause: error });
  }
}
